import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * Ai mở được màn Chống gian lận.
 *
 * ⚠️ CHỈ hai vai (admin, director) — máy chủ cấp `fraud.read` cho đúng hai vai đó.
 *
 * Trưởng cửa hàng KHÔNG vào được, kể cả cho cơ sở mình, và đó là CHỦ Ý chứ không
 * phải chỗ quên: vai này có thể chính là một nửa của cặp cần soi, nên cho họ xem
 * cờ của cơ sở mình là cho họ xem cờ của chính mình.
 */
export function canSeeFraudBoard(): boolean {
  return hasPermission(ACTION.FraudRead);
}

/**
 * Ai bấm được nút "Gỡ oan".
 *
 * Hôm nay trùng đúng `canSeeFraudBoard`, nhưng giữ RIÊNG hai hàm: máy chủ khai hai
 * action riêng (`fraud.read`, `risksignal.void`), nên ngày nào một trong hai đổi
 * thì chỗ này đổi theo được mà không phải gỡ một cổng đã gộp.
 */
export function canVoidRiskSignal(): boolean {
  return hasPermission(ACTION.RiskSignalVoid);
}

/**
 * Ai ghi được trạng thái soi + ghi chú riêng (QĐ 0376).
 *
 * Máy chủ DÙNG LẠI action `risksignal.void` cho cửa này (cùng màn, cùng nhóm
 * người được quyết trên sổ) — nên ở đây cũng đọc đúng action đó.
 */
export function canWriteFraudCase(): boolean {
  return hasPermission(ACTION.RiskSignalVoid);
}
